<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }">
        <div v-show="isNavigationInitialized">
			<div class="btn-close" >
				<svg class="mobile-nav__chevron" fill="currentColor" width="24" height="24" @click="closeNavigation()">
					<use xlink:href="#cancel" />
				</svg>
			</div>

		<ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">

			<div id="accordion" class="accordion">
				<div v-for="category in dataContainer1.categories" class="card" :class="{'about-cat': category.id === 11, 'magazin-cat': category.id === 150 }">
					<div class="card-header" :id="'cat-heading-' + category.id">
						<button class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#cat-body-' + category.id" aria-expanded="true" :aria-controls="'cat-body-' + category.id">
							<span>{{category.details[0].name}}</span>
							<svg class="mobile-nav__chevron" fill="currentColor">
								<use xlink:href="#chevron-down" />
							</svg>
						</button>
					</div>
					<div :id="'cat-body-' + category.id" class="collapse" :aria-labelledby="'cat-heading-' + category.id" data-parent="#accordion">
						<div class="card-body">
							<ul>
								<li class="show-all">
									<a :href="getCategoryUrl(category.url)">
										<template v-if="category.id === 11">
											{{ $translate("HoferAntikschmuck::Template.showAllAboutUs") }}
										</template>
                                        <template v-else-if="category.id === 150">
											{{ $translate("HoferAntikschmuck::Template.showAllMagazin") }}
										</template>
										<template v-else>
											{{ $translate("HoferAntikschmuck::Template.all") }} {{category.details[0].name}}
										</template>
									</a>
								</li>
								<li v-for="child in category.children">
									<a  :href="getCategoryUrl(child.url)">{{child.details[0].name}}</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

            <hr>

			<div id="accordion-2" class="accordion">
				<div class="card">
					<div class="card-header" id="cat-heading-links">
						<button class="btn btn-link" data-toggle="collapse" data-target="#cat-body-links" aria-expanded="true" aria-controls="cat-body-links">
							<span>{{ $translate("HoferAntikschmuck::Template.myHofer") }}</span>
							<svg class="mobile-nav__chevron" fill="currentColor">
								<use xlink:href="#chevron-down" />
							</svg>
						</button>
					</div>
					<div id="cat-body-links" class="collapse show" aria-labelledby="'cat-heading-links" data-parent="#accordion-2">
						<div class="card-body">
							<ul>

								<user-login-handler :is-mobile-nav="true"></user-login-handler>

								<li>
									<a :href="$ceres.urls.basket">
										<svg stroke="currentColor">
											<use xlink:href="#shopping-bag" />
										</svg>
										<span>{{ $translate("HoferAntikschmuck::Template.headerBasketLabel") }}</span>
									</a>
								</li>
								<li>
									<a :href="$ceres.urls.wishList">
										<svg stroke="currentColor">
											<use xlink:href="#wishlist" />
										</svg>
										<span>{{ $translate('Ceres::Template.wishList') }}</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<hr>

			<slot name="languageselect"></slot>

		</ul>
	</div>
</div>
</template>

<script>
import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        // initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean,
		languageList: Array,
		langLink: String
    },

    data()
    {
        return {
			initialCategory: null,
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null
        };
    },

    computed:
    {
        breadcrumbs()
        {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length)
            {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created()
    {
        this.$store.commit("setCurrentCategory", null);
    },

    mounted()
    {
        this.addEventListener();
    },

    methods:
    {
        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.loadInitialTree();
            }
        },

        loadInitialTree()
        {
            if (this.navigationTree.length <= 0)
            {
                const categoryId = null;

                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation()
        {
            if (this.initialCategory && this.initialCategory.id)
            {
                if (this.initialCategory.linklist === "N")
                {
                    this.$store.commit("setCurrentCategory", this.initialCategory);
                }
                else
                {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory)
        {
            if (currentCategory)
            {
                if (currentCategory.children)
                {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent)
                {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back)
        {
            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer)
            {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId)
        {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
            {
                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId)
        {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers)
            {
                if (category)
                {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else
                {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree)
        {
            for (const cat of tree)
            {
                if (categoryId === cat.id)
                {
                    return cat;
                }
                else if (cat.children)
                {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat)
                    {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url)
        {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return prefix + url;
        }
    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
